import { firstValueFrom } from 'rxjs';
import { SecurityService } from '~/services/security.service';

const PUBLIC_ROUTES = new Set([
  '/login',
  '/reset-password'
]);

export function appInitializer(securityService: SecurityService) {
  return async (): Promise<void> => {
    const path = window.location.pathname
      .toLowerCase()
      .replace(/\/+$/, ''); // Remove trailing slashes

    const hasToken = !!localStorage.getItem('accessToken');

    const isPublicRoute =
      PUBLIC_ROUTES.has(path) ||
      path.includes('renderreport');

    if (!hasToken || isPublicRoute) {
      return;
    }

    try {
      await firstValueFrom(securityService.setCurrentUser());
    } catch (error) {
      console.error('Failed to initialize current user.', error);
    }
  };
}